module.exports = __webpack_public_path__ + "img/90.b34da0c6.jpg";